

export function getFaqList(t, type?: string) {
  const depositList = [
    {
      key: 'deposits-successNoArrivalQ',
      title: t('deposits.faq.successNoArrivalQ'),
      description: t('deposits.faq.successNoArrivalA')
    },
    {
      key: 'deposits-pendingQ',
      title: t('deposits.faq.pendingQ'),
      description: t('deposits.faq.pendingA')
    },
    {
      key: 'deposits-failedQ',
      title: t('deposits.faq.failedQ'),
      description: t('deposits.faq.failedA')
    },
    {
      key: 'deposits-noRefundQ',
      title: t('deposits.faq.noRefundQ'),
      description: t('deposits.faq.noRefundA')
    }
  ];

  const withdrawList = [
    {
      key: 'withdrawals-successNoArrivalQ',
      title: t('withdrawals.faq.successNoArrivalQ'),
      description: t('withdrawals.faq.successNoArrivalA')
    },
    {
      key: 'withdrawals-pendingQ',
      title: t('withdrawals.faq.pendingQ'),
      description: t('withdrawals.faq.pendingA')
    },
    {
      key: 'withdrawals-failedQ',
      title: t('withdrawals.faq.failedQ'),
      description: t('withdrawals.faq.failedA')
    }
  ];

  if (type === 'deposit') {
    return depositList;
  } else if (type === 'withdraw') {
    return withdrawList;
  }

  return [
    ...depositList,
    ...withdrawList
  ];
}